<template>
    <div>
    	<div>
            <Row class="expand-row">
                <Col span="12">
                    <span class="expand-key">{{$t('RAM.AWS.StorageBin.binAuthorization')}}: </span>
                    <span class="expand-value">{{ row.displayId }}</span>
                </Col>
                <Col span="12">
                    <span class="expand-key">{{$t('RAM.AWS.StorageBin.public')}}: </span>
                    <span class="expand-value">{{ row.access }}</span>
                </Col>
            </Row>
            <Row class="expand-row">
                <Col span="12">
                    <span class="expand-key">{{$t('RAM.AWS.StorageBin.encryption')}}: </span>
                    <span class="expand-value">{{ row.defaultEncryption }}</span>
                </Col>
                <Col span="12">
                    <span class="expand-key">{{$t('RAM.AWS.StorageBin.lifeCycle')}}: </span>
                    <span class="expand-value">{{ row.lifeCycleRule }}</span>
                </Col>
            </Row>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            row: Object
        }
    };
</script>
<style scoped>
    .expand-row{
    	padding-left: 17px;
        margin-bottom: 10px;
    }
    .expand-key
    {
    	display: block;
    	float: left;
    }
</style>


// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/s3/TableExpand.vue